module.exports = __webpack_public_path__ + "img/award.4492f952.svg";